import polyLogo from '../poly-dark-bg.svg';

function Banner() {
  const style = {
    color: 'white',
  };

  return (
    <div className="banner">
      <a
        target="#"
        href="https://www.poly.com/us/en/products/services/cloud/realconnect"
      >
        <img
          className="float-left"
          src={polyLogo}
          height="30px"
          alt="Poly Logo"
        />
      </a>
      <a
        style={style}
        className="float-right"
        href="https://rc-docs.plcm.vc"
        target="#"
      >
        HELP
      </a>{' '}
      &nbsp;
    </div>
  );
}

export default Banner;
